import { QUALITY_BAND_COLORS, QUALITY_BAND_THRESHOLDS } from "../flag-qa-types";

const BANDS = [
  { label: "Low", threshold: `<${QUALITY_BAND_THRESHOLDS.low}%`, color: QUALITY_BAND_COLORS.low },
  {
    label: "Moderate",
    threshold: `${QUALITY_BAND_THRESHOLDS.low}-${QUALITY_BAND_THRESHOLDS.moderate}%`,
    color: QUALITY_BAND_COLORS.moderate,
  },
  { label: "High", threshold: `>${QUALITY_BAND_THRESHOLDS.moderate}%`, color: QUALITY_BAND_COLORS.high },
] as const;

export function FlagQaF1Legend() {
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-tertiary font-medium">F1:</span>
      {BANDS.map((band) => (
        <span
          key={band.label}
          className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold"
          style={{
            border: `1px solid ${band.color}`,
            color: band.color,
          }}
        >
          {band.label}
        </span>
      ))}
    </div>
  );
}
